import { Pill } from '@msaf/core-react'

export interface PillSelectedProps {
  isEnabled?: boolean
  modifyValues: () => void
  label: string
  displaySegments: ({ value: string } | { operator: string })[]
}

export function PillSelected({ isEnabled, modifyValues, label, displaySegments }: PillSelectedProps) {
  const pillContent = displaySegments.map((segment, i) => Object.values(segment).join(' ')).join(' ')

  return <Pill label={label} value={pillContent} handleClick={modifyValues} isSelected={!!isEnabled} />
}
